import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { ValidatorForm, TextValidator,SelectValidator} from 'react-material-ui-form-validator';
import MenuItem from '@material-ui/core/MenuItem';
import SendIcon from '@material-ui/icons/Send';
import {AuthContext} from '../../../../../context/AuthContext'
import SelectDate from '../../../../../utils/select_date'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
 export default class App extends React.Component {




    render() {
        const { user } = this.props.state ;
 const {handleChange,handleNext,handleBack,classes,direct_call}=this.props


if(direct_call)
return(
  <List disablePadding>

  <ListItem className={classes.listItem} >
    <ListItemText  >
<Typography variant="subtitle2">Name</Typography>
    </ListItemText>
    <Typography variant="body2">{user.name}</Typography>
  </ListItem>
  <ListItem className={classes.listItem} >
    <ListItemText  >
<Typography variant="subtitle2">Date of Birth</Typography>
    </ListItemText>
    <Typography variant="body2">{`${('0'+user.dd.toString()).slice(-2)}/${('0' + user.mm.toString()).slice(-2)}/${user.yy}`} (dd/mm/yyyy)</Typography>
  </ListItem>
  </List>
)
        return (
          <>

              <ValidatorForm
                onSubmit={handleNext}
            >

     <TextValidator
                                          label="Name"
                                           onChange={ handleChange}
                                            name="name"
                                            variant="outlined"
                                              value={user.name}
                                          validators={['required']}
                                          errorMessages={['this field is required',]}
                                       />



                                      <br />



<SelectDate   handleChange={handleChange} dd={user.dd} mm={user.mm} yy={user.yy}/>




<br />
{!direct_call &&
   <div className={classes.buttons}>
   <Button type="button"  className={classes.button} onClick={handleBack}    color="primary"  >
         PREV
       </Button>
<Button type="submit"   className={classes.button}   variant="contained" color="secondary"  endIcon={<SendIcon/>}>
      NEXT

    </Button>


</div>
}



            </ValidatorForm>


            </>
        );
    }
 }
